import React, { useEffect, useMemo } from 'react';
import locales from '../../../content.json';

import bgAvif from './img/bg.avif';
import bg from './img/bg.jpg';


import {
  analyticsEventsTracker,
  GTMOnboardingFunnelEvent,
  EVENT_TRACKERS,
} from '../../../utils/analytics';
import { getParameterFromURL } from '../../../utils/scripts';

import s from './index.module.scss';

export const MainScreenVet = () => {
  const subscrUK = getParameterFromURL('subscrUK');
  const version = subscrUK ? 'version2UK' : 'version2';

  const headerText = locales[window.userLang].payment_text_281;

  useEffect(() => {
    analyticsEventsTracker.trackWithTarget(
      GTMOnboardingFunnelEvent.showPaywall(version),
      EVENT_TRACKERS.GTM,
    );
  }, []);

  return (
    <div className={s.container}>
      <h2 className={s.title}>{headerText}</h2>

      <p
        className={s.subtitle}
        dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_282 }}
      />

      <picture className={s.heroImage}>
        <source srcSet={bgAvif} type="image/avif" />
        <img src={bg} alt="Puppy training preview" />
      </picture>
    </div>
  );
};
